import { z } from 'zod';

export const ACKNOWLEDGEMENT_TYPE = {
  Acknowledgement: 0,
  Document: 1,
} as const;

export type AcknowledgementType = keyof typeof ACKNOWLEDGEMENT_TYPE;

const AcknowledgementSchema = z.object({
  AcknowledgementType: z.string(),
  AcknowledgementId: z.number(),
  AcknowledgementTitle: z.string(),
  AcknowledgementFileName: z.string(),
  Version: z.string().optional(),
  ContentType: z.string(),
  ClientId: z.number(),

  DocumentId: z.string().uuid().optional(),
  IsLegacy: z.boolean().optional(),
});

export const AcknowledgementsSchema = z.array(AcknowledgementSchema);

export const AcknowledgementsResponseSchema = z.object({
  Acknowledgements: AcknowledgementsSchema,
  ClientId: z.number(),
});

export const AcknowledgedSchema = z.object({
  ClientId: z.number().int(),
  AcknowledgementId: z.number().int(),
  AcknowledgementType: z.union([
    z.literal(ACKNOWLEDGEMENT_TYPE.Acknowledgement),
    z.literal(ACKNOWLEDGEMENT_TYPE.Document),
  ]),
  Acknowledged: z.boolean(),
});

export const AcknowledgeResponseSchema = z.object({
  ClientId: z.number().int().optional(),
  AcknowledgementType: z.string().optional(),
  AcknowledgementId: z.number().int().optional(),
  Acknowledged: z.boolean().optional(),
  DocumentId: z.number().int().optional(),
  success: z.boolean().optional(),
  error: z.string().optional(),
  message: z.string().optional(),
});

export type Acknowledgement = z.infer<typeof AcknowledgementSchema>;
export type Acknowledgements = z.infer<typeof AcknowledgementsSchema>;
export type AcknowledgementsResponse = z.infer<typeof AcknowledgementsResponseSchema>;
export type Acknowledged = z.infer<typeof AcknowledgedSchema>;
export type AcknowledgeResponse = z.infer<typeof AcknowledgeResponseSchema>;
